<template>
  <q-item
    clickable
    class="BtnSide w-40 h-40 !min-h-0 bg-neutral-100 rounded border border-white/10 absolute -right-[1.2rem] bottom-0 translate-y-1/2 z-50"
    @click="$emit('click:btn-side')"
  >
    <div id="cta">
      <span class="arrow primary">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 16L17.5 12L13.5 8"
            stroke="rgba(var(--white), .40)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.4"
            d="M6.5 17L11.5 12L6.5 7"
            stroke="rgba(var(--white), .40)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span class="arrow secound">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 16L17.5 12L13.5 8"
            stroke="rgba(var(--white), .40)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            opacity="0.4"
            d="M6.5 17L11.5 12L6.5 7"
            stroke="rgba(var(--white), .40)"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </q-item>
</template>

<script setup>
const emits = defineEmits(['click:btn-side'])
</script>

<style lang="scss" scoped>
.sidebar-active {
  .BtnSide {
    .arrow {
      svg {
        transform: rotate(180deg);
      }
    }
    &:hover {
      .arrow {
        animation-name: bounceAlpha !important;

        &.primary {
          animation-name: bounceAlpha !important;
        }
      }
    }
  }
}

.OSidebar .BtnSide {
  #cta {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .arrow {
      width: 20px;
      height: 20px;
      margin-bottom: unset;
      position: absolute;

      animation-duration: 1.4s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

    .primary {
      animation-duration: 1.4s;
      animation-delay: 0.2s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
  }

  &:hover {
    .arrow {
      animation-name: bounceAlphaClosed;

      &.primary {
        animation-name: bounceAlphaClosed;
      }
    }
  }
}

@keyframes bounceAlpha {
  0% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
  25% {
    opacity: 0;
    transform: translateX(-10px) scale(0.9);
  }
  26% {
    opacity: 0;
    transform: translateX(10px) scale(0.9);
  }
  55% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
}

@keyframes bounceAlphaClosed {
  0% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
  25% {
    opacity: 0;
    transform: translateX(10px) scale(0.9);
  }
  26% {
    opacity: 0;
    transform: translateX(-10px) scale(0.9);
  }
  55% {
    opacity: 1;
    transform: translateX(0px) scale(1);
  }
}
</style>
